import moment from "moment";
import { IFileUpload } from "../../../features/FileUpload/components/FileUpload.type";
import { LoadState } from "../../../constants/enums";
import { ITemplateField } from "../../CustomFormFields/CustomFormFields.types";


export interface ICommAutoPolicyMarketingBinderPdf {
  customer_policy_id: number;
  isMarketSubmissionPreview: boolean;
  pdfOrPreviewFor: string;
  isBinderPreview: boolean;
  isBinderPdf: boolean;
  generalInformation: boolean;
  driver: boolean;
  priorPolicy: boolean;
  claims: boolean;
  convictions: boolean;
  vehicle: boolean;
  coverage: boolean;
  garagePlat: boolean;
  customer_id?: number;
}
export interface ICommAutoChecklistResponse {
  lead_id?: string | null;
  binder_checklist_id?: number | null;
  binder_checklist_code?: string | null;
  customer_id: number;
  customer_policy_id: number;
  checklist: ITemplateField[];
  status: string;
  create_ts?: string;
  insert_ts?: string;
}

export interface ICommAutomobileMarketingHistoryState {
  marketingHistoryList: ICommAutomobileMarketingHistory[];
  marketingHistoryListLoading: LoadState;
  marketingHistory: ICommAutomobileMarketingHistory;
  marketingHistoryLoading: LoadState;
  error: string | null;
  binderHistory: {
    list: ICommAutoBinder[];
    loading: LoadState;
  };
  checklist: {
    savedStatus: boolean;
    savedStatusLoading: LoadState;
    response: ICommAutoChecklistResponse | null;
    responseLoading: LoadState;
    saveLoading: LoadState;
    error: string | null;
  };
}

export interface ICommAutoBinder {
  lead_id?: string | null;
  attachment: string;
  created_by_id: string;
  customer_policy_id: number;
  status: string;
}

export interface ICommAutomobileMarketingHistory {
  lead_id?: string | null;
  customer_policy_id: number;
  quote_number: number | null;
  serial_number: string | null;
  customer_name: string | null;
  quote_status: string | null;
  premium: string | null;
  submission_date: string | null;
  effective_date: string | null;
  date_received: string | null;
  insurer: string | null;
  underwriter: string | null;
  assigned_to_id: string | null;
  assigned_to_name: string | null;
  attachment: IFileUpload[];
  quote_attachment?: IFileUpload[];
  notes: string | null;
  status: string;
  created_by_name?: string | null;
  modified_by_name?: string | null;
}

export const initialCommAutomobileMarketingHistory: ICommAutomobileMarketingHistory = {
  lead_id: null,
  customer_policy_id: 0,
  quote_number: null,
  serial_number: null,
  customer_name: null,
  quote_status: null,
  premium: null,
  submission_date: moment().format("YYYY-MM-DD"),
  effective_date: null,
  date_received: null,
  insurer: null,
  underwriter: null,
  assigned_to_id: null,
  assigned_to_name: null,
  attachment: [],
  quote_attachment: [],
  notes: null,
  status: "ACTIVE",
};

export const initialCommAutomobileMarketingHistoryState: ICommAutomobileMarketingHistoryState =
  {
    marketingHistoryList: [],
    marketingHistoryListLoading: LoadState.NotLoaded,
    marketingHistory: initialCommAutomobileMarketingHistory,
    marketingHistoryLoading: LoadState.NotLoaded,
    error: null,
    binderHistory: {
      list: [],
      loading: LoadState.NotLoaded
    },
    checklist: {
      savedStatus: false,
      savedStatusLoading: LoadState.NotLoaded,
      response: null,
      responseLoading: LoadState.NotLoaded,
      saveLoading: LoadState.NotLoaded,
      error: null,
    },
  };
